import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  monitorConfig,
  testConfig
} from '../../docs-routes'
import {
  useConfigTypeTitle,
  useModule
} from '@eggplant/routing'

const LinkToTestConfigDoc = () => {
  const [isMonitorFlag] = useModule()
  const configTypeTitle = useConfigTypeTitle(true)

  const docsPath = !isMonitorFlag
    ? testConfig
    : monitorConfig

  return (
    <LinkToDocusaurus path={docsPath}>
      Learn more about {configTypeTitle} Config
    </LinkToDocusaurus>
  )
}

export default LinkToTestConfigDoc
